module.exports = __webpack_public_path__ + "./fonts/DMSans-Regular.7795a4.woff2";